/** Viene usato per dare un ordinamento di default alle entità ordinabili quando vengono create. 
 * In futuro dovrebbe essere gestito dal BE il calcolo automatico del valore massimo del sorting.
 */
export const MAX_SORT_VALUE = 2147483647;
